import {
  CloseButton,
  Popover as P,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";
import React, { ReactNode } from "react";

interface PopoverOption {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
}

export default function Popover({
  buttonBody,
  options,
}: {
  buttonBody: ReactNode;
  options: PopoverOption[];
}) {
  return (
    <P className="relative h-10">
      <PopoverButton className="text-electrum focus:outline-none">
        {buttonBody}
      </PopoverButton>
      <PopoverPanel
        anchor="bottom"
        className="flex flex-col bg-white min-w-48 py-4 px-2 mt-2 rounded-md shadow-md border border-[#E0E0E0]"
      >
        {options.map((option, i) => (
          <CloseButton
            key={`${option.label}_${i}`}
            onClick={option.disabled ? undefined : option.onClick}
            className={`rounded-sm px-4 py-2 text-left ${
              option.disabled
                ? "text-gray-400 cursor-not-allowed"
                : "hover:bg-[#F5F5F5]"
            }`}
            disabled={option.disabled}
            title={option.title}
          >
            {option.label}
          </CloseButton>
        ))}
      </PopoverPanel>
    </P>
  );
}
